import { UserUniqueIdentifierValue } from '@frontend/account/types';
import type { Account } from '@frontend/account/types';
import { UserClient } from '@frontend/user/api';
import type { IUser } from '@frontend/user/types';

export type UserEmailLookupField = 'email' | 'unique_identifier';
export const OPEN_DROP_OFF_QR_USER_RESOLUTION_KEY = 'openDropOffQrUserResolution';

export interface OpenDropOffQrUserResolution {
    trackingNumber: string;
    senderEmail: string;
    receiverEmail: string;
    lookupField: UserEmailLookupField;
    senderCandidates: IUser[];
    receiverCandidates: IUser[];
}

export const normalizeEmail = (email: string) => email.trim().toLowerCase();

export const getUserEmailLookupField = (accounts: Account[], accountId: string): UserEmailLookupField => {
    const accountInfo = accounts.find((account) => account.id === accountId);
    return accountInfo?.user_identifier_field === UserUniqueIdentifierValue.EMAIL ? 'unique_identifier' : 'email';
};

export const getUserEmailValue = (user: IUser, lookupField: UserEmailLookupField): string | null =>
    lookupField === 'unique_identifier' ? user.unique_identifier : user.email;

export const findUsersByEmail = async (accountId: string, email: string, lookupField: UserEmailLookupField): Promise<IUser[]> => {
    const response = await UserClient.fetchUsers({
        account_id: accountId,
        [lookupField]: email,
        search_mode: 'exact',
        size: '100'
    });
    const normalizedEmail = normalizeEmail(email);

    return response.results.filter((user) => normalizeEmail(getUserEmailValue(user, lookupField) ?? '') === normalizedEmail);
};
